import React from 'react';

function PaymentUnsuccessfulIcon() {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3113_24294)'>
        <path
          d='M20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38Z'
          stroke='#C9CDCF'
          strokeWidth='2.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M7 32L32 7' stroke='#C9CDCF' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M11 29H29' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M14 25V18' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M18 25V18' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M22 25V18' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M26 25V18' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M20 9L28 14H12L20 9Z' stroke='#464F53' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_3113_24294'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PaymentUnsuccessfulIcon;
